import { render, staticRenderFns } from "./personCenter.vue?vue&type=template&id=67d4bf82&scoped=true&"
import script from "./personCenter.vue?vue&type=script&lang=js&"
export * from "./personCenter.vue?vue&type=script&lang=js&"
import style0 from "./personCenter.vue?vue&type=style&index=0&id=67d4bf82&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4bf82",
  null
  
)

export default component.exports